import { checkConsent, consentCategories } from 'utils/cookies';

interface GoogleAnalyticsEventObj {
  name?: string;
  version?: string;
  event_category?: string;
  event_action?: string;
  event_label?: string;
  page_path?: string;
  page_location?: string;
  custom?: {
    [key: string]: any;
  };
  params?: {
    [key: string]: any;
  };
}

declare const window: Window & {
  sendEvent?: (eventObj: GoogleAnalyticsEventObj) => void;
};

export const logRegistryEvent = (action: string, label: string) => {
  const eventInfo = {
    event_category: 'gift_registry',
    event_action: action,
    event_label: label,
  };
  return checkConsent(consentCategories.performanceCookies) &&
    typeof window.sendEvent === 'function'
    ? window.sendEvent(eventInfo)
    : console.info(eventInfo);
};
